// @ts-nocheck TODO: fix types for the entire file

import styled from '@emotion/styled';
import pxToEm from 'theme/pxToEm';

export const Wrapper = styled.div<{ withMobilePadding?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  max-width: 100%;
  ${({ withMobilePadding, theme }) =>
    withMobilePadding &&
    theme.breakpoints.down(767) &&
    `
  position: relative;
  &:after {
    content: '';
    display: block;
    width: 12px;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    background: linear-gradient(270deg, rgb(255, 255, 255) 0%, rgba(255, 255, 255, 0) 100%);
  }
  `}
`;

export const CategoriesWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const SubcategoriesWrapper = styled.div<{ hasRightElement?: boolean }>`
  display: flex;
  max-width: 100%;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin-top: ${pxToEm(14)};
  ${({ theme }) => theme.breakpoints.down(767)} {
    flex-direction: column;
  }
`;

export const SubcategoriesScrollerWrapper = styled.div<{ widthLimit?: number }>`
  width: 100%;
  ${({ theme }) => theme.breakpoints.up(768)} {
    width: calc(100% - ${({ widthLimit }) => widthLimit || 0}px);
  }
  ${({ theme }) => theme.breakpoints.down(767)} {
    margin-bottom: 1em;
  }
`;

export const MarginAddon = styled.div<{ withMobilePadding?: boolean }>`
  width: 4px;
  height: 36px;
  display: none;
  pointer-events: none;
  flex-shrink: 0;
  ${({ withMobilePadding, theme }) =>
    withMobilePadding &&
    theme.breakpoints.down(767) &&
    `
    display: block;
  }
  `}
`;
